import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import { TechnicianInfo } from "../../../utils/makeTechnicianInfo";

type Variation = "compact" | "inline";

type PdfTechnicianSignatureProps = {
	technician: TechnicianInfo;
	breakPage?: boolean;
	variation?: Variation;
};

const variationStyles: Record<Variation | "default", {
	container: keyof typeof styles;
	signature: keyof typeof styles;
	separator: keyof typeof styles;
	name: keyof typeof styles;
	info: keyof typeof styles;
}> = {
	default: { container: "signatureContent", signature: "signature", separator: "separator", name: "technicianName", info: "professionalInfo" },
	compact: { container: "signatureContentCompact", signature: "signatureCompact", separator: "separatorCompact", name: "technicianNameCompact", info: "professionalInfoCompact" },
	inline: { container: "signatureContentInline", signature: "signature", separator: "separator", name: "technicianNameCompact", info: "professionalInfoCompact" },
};

export const PdfTechnicianSignature = ({ technician, breakPage = false, variation }: PdfTechnicianSignatureProps) => {
	const keys = variationStyles[variation ?? "default"];

	const containerStyle = styles[keys.container];
	const signatureStyle = styles[keys.signature];
	const separatorStyle = styles[keys.separator];
	const nameStyle = styles[keys.name];
	const infoStyle = styles[keys.info];

	return (
		<View style={containerStyle} break={breakPage} wrap={false}>
			{technician.signatureUrl && <Image style={signatureStyle} src={technician.signatureUrl} />}
			<View style={separatorStyle} />
			<Text style={nameStyle}>{technician.name}</Text>
			<Text style={infoStyle}>
				{technician.title && technician.title} {technician.license && `(${technician.license})`}
			</Text>
		</View>
	);
};

export const styles = StyleSheet.create({
	signatureContent: {
		alignSelf: "flex-end",
		alignItems: "center",
		position: "absolute",
		right: 30,
		bottom: 30,
	},
	signatureContentCompact: {
		alignSelf: "flex-end",
		alignItems: "center",
		position: "absolute",
		right: 0,
		bottom: 5,
		transform: "translateY(20px)",
	},
	signature: {
		width: 100,
		height: "auto",
		transform: "translateY(4px)",
	},
	signatureCompact: {
		width: 75,
		height: "auto",
		transform: "translateY(3px)",
	},
	professionalInfo: {
		fontSize: 10,
		textAlign: "center",
	},
	professionalInfoCompact: {
		fontSize: 8,
		textAlign: "center",
	},
	technicianName: {
		fontSize: 10,
	},
	technicianNameCompact: {
		fontSize: 8,
	},
	separator: {
		marginBottom: 6,
		borderWidth: 0.5,
		borderColor: "#000",
		borderStyle: "solid",
		width: "150px",
	},
	separatorCompact: {
		marginBottom: 4,
		borderWidth: 0.5,
		borderColor: "#000",
		borderStyle: "solid",
		width: "110px",
	},
	signatureContentInline: {
		flex: 1,
		alignItems: "center",
	},
});
